import * as firebase from 'firebase'
import moment from 'moment'

import QueryBuilder from './QueryBuilder'

const CommonRepository = {

  addDefaultMaterial: (teamId, material) => {
    const dbRef = firebase.database().ref(`teams/${teamId}/defaultMaterials`)
    const dbKey = dbRef.push().key
    material.id = dbKey
    dbRef.child(dbKey).set(material)
  },

  addDefaultBillItem: (teamId, invoiceItem) => {
    const dbRef = firebase.database().ref(`teams/${teamId}/defaultInvoiceItems`)
    const dbKey = dbRef.push().key
    invoiceItem.id = dbKey
    dbRef.child(dbKey).set(invoiceItem)
  },

  addEventInstancePhotosListener: (eventId, instanceDateStr, listener) => {
    firebase.database()
      .ref(`events/${eventId}/extendedInfo/modules/photos/list`)
      .orderByChild('jobDateStr')
      .equalTo(instanceDateStr)
      .limitToFirst(10)
      .on('value', listener)
  },

  removeEventInstancePhotosListener: (eventId, instanceDateStr, listener) => {
    firebase.database()
      .ref(`events/${eventId}/extendedInfo/modules/photos/list`)
      .orderByChild('jobDateStr')
      .equalTo(instanceDateStr)
      .limitToFirst(10)
      .off('value', listener)
  },

  addEventPhotosListener: (eventId, listener) => {
    firebase.database()
      .ref(`events/${eventId}/extendedInfo/modules/photos/list`)
      .limitToFirst(10)
      .on('value', listener)
  },

  removeEventPhotosListener: (eventId, instanceDateStr, listener) => {
    firebase.database()
      .ref(`events/${eventId}/extendedInfo/modules/photos/list`)
      .limitToFirst(10)
      .off('value', listener)
  },

  getImageURL: photoDbPath => {
    return firebase.storage()
      .ref(photoDbPath)
      .getDownloadURL()
  },

  addCustomerEventsListener: (teamId, customerId, contactId, from, to, listener) => {
    // If not specified, query events in a month timespan from today.
    const f = from || moment().add(-30, 'days').format('YYYY-MM-DD')
    const t = to || moment().add(30, 'days').format('YYYY-MM-DD')
    const query = QueryBuilder.buildCustomerEventsQuery(teamId, customerId, contactId, f, t)
    if (query) {
      query.on('value', listener)
    }
  },

  removeCustomerEventsListener: (teamId, customerId, contactId, from, to, listener) => {
    const f = from || moment().add(-30, 'days').format('YYYY-MM-DD')
    const t = to || moment().add(30, 'days').format('YYYY-MM-DD')
    const query = QueryBuilder.buildCustomerEventsQuery(teamId, customerId, contactId, f, t)
    if (query) {
      query.off('value', listener)
    }
  },
  
  addCustomersListener: (teamId, listener) => {
    firebase.database()
      .ref(`customers/${teamId}`)
      .on('value', listener)
  },

  removeCustomersListener: (teamId, listener) => {
    firebase.database()
      .ref(`customers/${teamId}`)
      .off('value', listener)
  }
  
}

export default CommonRepository



// WEBPACK FOOTER //
// ./src/billing/infra/CommonRepository.js